define('container/argResolvers/WPArgResolver',['underscore'], function(_) {

    'use strict';

    function WPArgResolver(wpServiceId) {
        this.wpServiceId = wpServiceId;
    }

    WPArgResolver.prototype.canResolveArg = function(argDefinition) {
        return argDefinition.substring(0, 2) === 'wp';
    };

    WPArgResolver.prototype.resolveArg = function(argDefinition, extensionApi) {

        var parts = argDefinition.split(':');
        var contentInterface = parts[2] === 'market' ? 'marketInterface' : 'rootContent';

        return extensionApi.container.get(this.wpServiceId).then(function(wp) {

            var slugs = parts[3].split('/');

            var page = _.reduce(
                _.tail(slugs),
                function(page, slug) {
                    return page.getChildBySlug(slug);
                },
                wp[contentInterface].getRootPageBySlug(slugs[0])
            );

            if (parts[1] === 'cmf') {
                return wp.makeConstructorMapperFactory(page);
            }

            return page;

        });
    };

    return WPArgResolver;
});

